import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { Company } from "../models/company";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class CompanyService extends BaseService {

    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    public getCompanies(searchText: string): Observable<Company[]> {
        return super.get(`/api/companies/${searchText}`).pipe(
            map((res: any) => res as Company[])
        );
    }

    public getAll(): Observable<Company[]> {
        return super.get("/api/companies").pipe(
            map((res: any) => res as Company[])
        );
    }

    public addCompany(company: Company): Observable<Company> {
        return super.post("/api/companies/", company).pipe(
            map((res: any) => res as Company)
        );
    }
}





